import { Component, OnInit } from '@angular/core';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { TextosService } from 'src/app/services/textos.service';
import { InventarioService } from 'src/app/services/inventario.service';
import { Lentes } from 'src/app/models/Lentes';

declare var $: any;

@Component({
  selector: 'app-listadodelentes',
  templateUrl: './listadodelentes.component.html',
  styleUrls: ['./listadodelentes.component.css']
})
export class ListadodelentesComponent implements OnInit {

  lentesinfo: Lentes = {
    tipopersonal: '',
    categoria: '',
    plaza: '',
    nss: 0,
    folio_sat: '',
    importe: 0,
    no_factura: '',
    fecha_factura: '',
    fecha_receta: '',
    beneficiado: '',
    fecha_pago: '',
    emisor: '',
    observacion: '',
    no_oficio: '',
    fecha_oficio: '',
    numempleado: '',
    periodo: '',
    fechapago:'',
    totalfactura:'',
    isr:'',
quincena_pago:''
  }

  // Beneficiarios dinámicos
  beneficiados: any[] = [];
  idlentes: any =[];

  // Nombre del empleado principal seleccionado
  nombreEmpleadoSeleccionado: string = '';

  // permisos
  DireccionGeneral = false;
  eliminaAsignatura = true;
  agregarAsignatura = true;
  editarAsignatura = true;

  datos = JSON.parse(localStorage.getItem('datos')!);
  mailusu = this.datos.correop;
  idplantel = this.datos.idplantel;
  idplantel1 = this.datos.idplantel;

  cargo: string;
  plantel: string;
  inventario: any = [];
  lentes: any = [];
  Nombre: string;
  infoplantel: any = [];
  empleado: any = [];
  periodoss: any = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

 ////////////////////////////////////
    archivo: File | null = null;
  xmllista: any = [];
  xmlPreview: any = {};  

  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router,
    private textosService: TextosService
  ) {
    this.cargo = this.datos.cargodb;
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      language: { url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json' }
    };
    this.getLentes();
    this.permisos();
    this.getplantelinfo();
    this.getEmpleado();
    this.getPeriodos();
  }

  limpiarLentes() {
    this.lentesinfo = {
      tipopersonal: '',
      categoria: '',
      plaza: '',
      nss: 0,
      folio_sat: '',
      importe: 0,
      no_factura: '',
      fecha_factura: '',
      fecha_receta: '',
      beneficiado: '',
      fecha_pago: '',
      emisor: '',
      observacion: '',
      no_oficio: '',
      fecha_oficio: '',
      numempleado: '',
      periodo: '',
      idplantel: null,
      totalfactura:'',
      isr:'',
      quincena_pago:''

    }
    this.beneficiados = [];
    this.nombreEmpleadoSeleccionado = '';

  }

  // Selección de empleado principal
// Selección de empleado principal
actualizarNombreEmpleado() {
  const numEmp = String(this.lentesinfo.numempleado);
  const empleadoSel = this.empleado.find(e => String(e.numpersonal) === numEmp);

  if (empleadoSel) {
    // 🔹 Validar si la plaza contiene la palabra DIRECTIV
    if (empleadoSel.plaza && empleadoSel.plaza.toUpperCase().includes("DIRECTIV")) {
      Swal.fire({
        title: 'Empleado no elegible',
        html: `
          <p style="text-align:center; color:#333;">
            Este empleado no puede solicitar la prestación por tener plaza de <b>Directivo</b>.
          </p>
        `,
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });

      // Limpiar campos del empleado seleccionado
      this.nombreEmpleadoSeleccionado = '';
      this.lentesinfo.beneficiado = '';
      this.lentesinfo.numempleado = '';
      this.lentesinfo.idplantel = null;
      this.lentesinfo.categoria = '';
      this.lentesinfo.plaza = '';
      this.lentesinfo.tipopersonal = '';
      return; // 🚫 Detiene aquí
    }

    // ✅ Si no es directivo, llenar normalmente los campos
    this.nombreEmpleadoSeleccionado = `${empleadoSel.nombre} ${empleadoSel.appaterno} ${empleadoSel.apmaterno}`;
    this.lentesinfo.beneficiado = this.nombreEmpleadoSeleccionado;
    this.lentesinfo.idplantel = empleadoSel.idplantel;
    this.lentesinfo.categoria = empleadoSel.puesto ?? ''; 
    this.lentesinfo.plaza = empleadoSel.plaza ?? '';
    this.lentesinfo.tipopersonal = empleadoSel.tipo_trabajador ?? '';
  } else {
    this.nombreEmpleadoSeleccionado = '';
    this.lentesinfo.beneficiado = '';
    this.lentesinfo.idplantel = null;
    this.lentesinfo.categoria = '';
    this.lentesinfo.plaza = '';
    this.lentesinfo.tipopersonal = '';
    this.lentesinfo.quincena_pago = '';
  }
}




  // BENEFICIARIOS
  agregarBeneficiado() {
    if (this.beneficiados.length < 5) {
      this.beneficiados.push({
        beneficiado: '',
        nss: '',
        folio_sat: '',
        importe: 0,
        emisor: '',
        no_factura: '',
        fecha_factura: '',
        fecha_receta: '',
        observacion: '',
        totalfactura:'',
        isr: '',
        quincena_pago:''
      });
    }
  }

  eliminarBeneficiado(index: number) {
    this.beneficiados.splice(index, 1);
  }

guardarLentes() {
  let mailusuario = this.mailusu;

  const empleadoSel = this.empleado.find(
    (e: any) => String(e.numpersonal) === String(this.lentesinfo.numempleado)
  );

  if (empleadoSel && empleadoSel.plaza && empleadoSel.plaza.toUpperCase().includes("DIRECTIV")) {
    Swal.fire({
      title: 'Empleado no elegible',
      html: `
        <p style="text-align:center; color:#333;">
          Este empleado no puede solicitar la prestación por tener plaza de <b>Directivo</b>.
        </p>
      `,
      icon: 'error',
      confirmButtonColor: '#720f3c'
    });
    return; // 🚫 No se guarda
  }

  if (!this.lentesinfo.no_factura || this.lentesinfo.no_factura.trim() === '') {
    Swal.fire({
      title: 'Campo obligatorio',
      html: '<p style="text-align:center; color:#333;">Debe ingresar el número de factura antes de guardar.</p>',
      icon: 'warning',
      confirmButtonColor: '#720f3c'
    });
    return;
  }

  if (this.beneficiados.length > 0) {
    const beneficiarioSinFactura = this.beneficiados.some(
      b => !b.no_factura || b.no_factura.trim() === ''
    );
    if (beneficiarioSinFactura) {
      Swal.fire({
        title: 'Falta No. factura en un beneficiario',
        html: '<p style="text-align:center; color:#333;">Cada beneficiario debe tener número de factura.</p>',
        icon: 'warning',
        confirmButtonColor: '#720f3c'
      });
      return;
    }
  }

  if (empleadoSel && empleadoSel.plaza && empleadoSel.plaza.toUpperCase().includes("ADMINISTRAT")) {
    this.inventarioService.validarApoyosLentes(this.lentesinfo.numempleado, this.lentesinfo.periodo)
      .subscribe((res: any) => {
        if (!res.permitido) {
          Swal.fire({
            title: 'Límite alcanzado',
            html: `<p style="text-align:center; color:#333;">
                     Este empleado ya tiene <b>2 apoyos</b> registrados en el periodo seleccionado.
                   </p>`,
            icon: 'warning',
            confirmButtonColor: '#720f3c'
          });
          return;
        }

        this.procesarGuardadoLentes(mailusuario);
      });
  } else {
    this.procesarGuardadoLentes(mailusuario);
  }
}


procesarGuardadoLentes(mailusuario: string) {
  this.inventarioService.getLesteslista().subscribe((lentesExistentes: any[]) => {
    const facturaDuplicada = lentesExistentes.some(
      l => l.no_factura && l.no_factura.trim().toUpperCase() === this.lentesinfo.no_factura.trim().toUpperCase()
    );

    if (facturaDuplicada) {
      Swal.fire({
        title: 'Factura duplicada',
        html: '<p style="text-align:center; color:#333;">El número de factura que intenta registrar ya existe en el sistema.</p>',
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });
      return;
    }

    this.inventarioService.createLentes(this.lentesinfo, mailusuario).subscribe(
      res => {
        if (res == "TOKEN-EXPIRADO") {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }

        for (let b of this.beneficiados) {
          const registroBeneficiado: Lentes = {
            ...this.lentesinfo,
            beneficiado: b.beneficiado,
            nss: Number(b.nss),
            folio_sat: b.folio_sat,
            importe: b.importe,
            emisor: b.emisor,
            no_factura: b.no_factura,
            fecha_factura: b.fecha_factura,
            fecha_receta: b.fecha_receta,
            observacion: b.observacion,
            totalfactura: b.totalfactura,
            isr: b.isr,
            quincena_pago : b.quincena_pago
          };
          this.inventarioService.createLentes(registroBeneficiado, mailusuario).subscribe();
        }

        Swal.fire({
          title: '<i style="color:#4CAF50;"></i> ¡Registrado correctamente!',
          html: '<p style="text-align:center; color:#333;">Se ha guardado correctamente al empleado y beneficiarios.</p>',
          icon: 'success',
          confirmButtonColor: '#720f3c',
        });

        setTimeout(() => location.reload(), 1500);
      },
      err => console.error(err)
    );
  });
}





  // Métodos existentes
  getLentes() {
    this.inventarioService.getLesteslistasiga().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.lentes = res; this.dtTrigger.next(); },
      err => console.error(err)
    );
  }

  permisos() {
    if (["Auxiliar Direccion Academica","Control Escolar Plantel","Director de Plantel","Planes y Programas DG","Servicios Docentes DG","DG Sin Permisos"].includes(this.cargo)) {
      this.eliminaAsignatura = false;
      this.agregarAsignatura = false;
      this.editarAsignatura = false;
    }
  }

  getplantelinfo() {
    this.inventarioService.getPlantelCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.infoplantel = res; },
      err => console.error(err)
    );
  }

  getEmpleado() {
    this.inventarioService.getEmpleadoCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.empleado = res; console.log("Empleados:", this.empleado); },
      err => console.error(err)
    );
  }

getPeriodos(){
       this.inventarioService.getPeriodoCatalogo().subscribe(
         res => {
   
           if(res=="TOKEN-EXPIRADO"){
             this.msj.tokenExpiradoCerrarSesion();   
             return;
         }
   
           this.periodoss = res;
   
         },
         err =>console.error(err)
       );
     }






eliminarlentes(id: any) {
  Swal.fire({
    title: '<i ></i><br>¿Desea eliminar el registro?',
    html: `
      <p style="text-align:center; color:#333; margin:10px 0;">
        Esta acción no se puede deshacer.
      </p>
    `,
    icon: 'warning',
    iconColor: '#c5ab5b',
    showCancelButton: true,
    confirmButtonColor: '#720f3c', // color vino
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    background: '#ffffff',
    backdrop: 'rgba(0,0,0,0.3)',
    allowOutsideClick: false,
    customClass: {
      popup: 'animated-popup shadow-lg rounded-3'
    },
    showClass: {
      popup: 'animate__animated animate__fadeInDown'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      // ✅ Elimina el registro si confirma
      this.inventarioService.deletelentes(id).subscribe(
        res => {
          if (res === "TOKEN-EXPIRADO") {
            this.msj.tokenExpiradoCerrarSesion();
            return;
          }

          Swal.fire({
            title: '<i ></i><br>¡Registro eliminado!',
            html: `
              <p style="text-align:center; color:#333; margin:10px 0;">
                El registro se ha eliminado correctamente.
              </p>
            `,
            icon: 'success',
            iconColor: '#4CAF50',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#720f3c',
            background: '#ffffff',
            backdrop: 'rgba(0,0,0,0.3)',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
              popup: 'animated-popup shadow-lg rounded-3'
            },
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          });

          // 🔄 Recargar después de 1.5 segundos
          setTimeout(() => {
            location.reload();
          }, 1500);
        },
        err => console.error(err)
      );

    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // ❌ Si cancela, cerrar el Swal
      Swal.close();

      // (Opcional) Mostrar mensaje de cancelación breve
      Swal.fire({
        title: '<i ></i><br>Acción cancelada',
        html: `
          <p style="text-align:center; color:#333; margin:10px 0;">
            No se realizaron cambios.
          </p>
        `,
        icon: 'info',
        iconColor: '#8f124d',
        showConfirmButton: false,
        timer: 1200,
        background: '#ffffff',
        backdrop: 'rgba(0,0,0,0.2)',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    }
  });
}

pagarlentes(id: any) {

  Swal.fire({
    title: '¿Se realizó el pago?',
    text: 'Esta acción no se puede deshacer.',
    icon: 'warning',
    iconColor: '#c5ab5b',
    showCancelButton: true,
    confirmButtonColor: '#720f3c',
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, se pagó',
    cancelButtonText: 'No, registrar pendiente',
    background: '#ffffff',
    backdrop: 'rgba(0,0,0,0.3)',
    allowOutsideClick: false
  }).then((result) => {

    // ------------------------------------
    //  SI SE PAGÓ → FECHA + QUINCENA
    // ------------------------------------
    if (result.isConfirmed) {

      Swal.fire({
        title: 'Fecha y quincena del pago',
        html: `
          <input type="date" id="fechaPago" class="swal2-input" style="width:75%;">

          <select id="quincenaSelect" class="swal2-input" style="width:75%;">
            <option value="">Seleccione quincena</option>
            <option>1A. QNA DE ENERO</option>
            <option>2A. QNA DE ENERO</option>
            <option>1A. QNA DE FEBRERO</option>
            <option>2A. QNA DE FEBRERO</option>
            <option>1A. QNA DE MARZO</option>
            <option>2A. QNA DE MARZO</option>
            <option>1A. QNA DE ABRIL</option>
            <option>2A. QNA DE ABRIL</option>
            <option>1A. QNA DE MAYO</option>
            <option>2A. QNA DE MAYO</option>
            <option>1A. QNA DE JUNIO</option>
            <option>2A. QNA DE JUNIO</option>
            <option>1A. QNA DE JULIO</option>
            <option>2A. QNA DE JULIO</option>
            <option>1A. QNA DE AGOSTO</option>
            <option>2A. QNA DE AGOSTO</option>
            <option>1A. QNA DE SEPTIEMBRE</option>
            <option>2A. QNA DE SEPTIEMBRE</option>
            <option>1A. QNA DE OCTUBRE</option>
            <option>2A. QNA DE OCTUBRE</option>
            <option>1A. QNA DE NOVIEMBRE</option>
            <option>2A. QNA DE NOVIEMBRE</option>
            <option>1A. QNA DE DICIEMBRE</option>
            <option>2A. QNA DE DICIEMBRE</option>
          </select>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const fecha = (document.getElementById('fechaPago') as HTMLInputElement).value;
          const quincena = (document.getElementById('quincenaSelect') as HTMLSelectElement).value;

          if (!fecha) {
            Swal.showValidationMessage('Debe ingresar la fecha de pago');
          }
          if (!quincena) {
            Swal.showValidationMessage('Debe seleccionar la quincena de pago');
          }

          return { fecha, quincena };
        }
      }).then((r2) => {
        if (r2.isConfirmed) {
          const datos = r2.value;

          this.inventarioService.pagarlentes(id, datos.fecha, datos.quincena, 1)
            .subscribe(() => {
              Swal.fire({
                title: '¡Pago registrado!',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });

              setTimeout(() => location.reload(), 1500);
            });
        }
      });

    } 
    // ------------------------------------
    //  NO SE PAGÓ → QUINCENA + PAGADO = 3
    // ------------------------------------
    else {

      Swal.fire({
        title: 'Seleccione la quincena del pago pendiente',
        html: `
          <select id="quincenaPendiente" class="swal2-input" style="width:75%;">
            <option value="">Seleccione quincena</option>
            <option>1A. QNA DE ENERO</option>
            <option>2A. QNA DE ENERO</option>
            <option>1A. QNA DE FEBRERO</option>
            <option>2A. QNA DE FEBRERO</option>
            <option>1A. QNA DE MARZO</option>
            <option>2A. QNA DE MARZO</option>
            <option>1A. QNA DE ABRIL</option>
            <option>2A. QNA DE ABRIL</option>
            <option>1A. QNA DE MAYO</option>
            <option>2A. QNA DE MAYO</option>
            <option>1A. QNA DE JUNIO</option>
            <option>2A. QNA DE JUNIO</option>
            <option>1A. QNA DE JULIO</option>
            <option>2A. QNA DE JULIO</option>
            <option>1A. QNA DE AGOSTO</option>
            <option>2A. QNA DE AGOSTO</option>
            <option>1A. QNA DE SEPTIEMBRE</option>
            <option>2A. QNA DE SEPTIEMBRE</option>
            <option>1A. QNA DE OCTUBRE</option>
            <option>2A. QNA DE OCTUBRE</option>
            <option>1A. QNA DE NOVIEMBRE</option>
            <option>2A. QNA DE NOVIEMBRE</option>
            <option>1A. QNA DE DICIEMBRE</option>
            <option>2A. QNA DE DICIEMBRE</option>
          </select>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const quincena = (document.getElementById('quincenaPendiente') as HTMLSelectElement).value;

          if (!quincena) {
            Swal.showValidationMessage('Debe seleccionar una quincena');
          }

          return quincena;
        }
      }).then((r3) => {
        if (r3.isConfirmed) {
          const quincena = r3.value;

          this.inventarioService.pagarlentes(id, null, quincena, 3)
            .subscribe(() => {
              Swal.fire({
                title: 'Pago marcado como pendiente',
                icon: 'info',
                timer: 1500,
                showConfirmButton: false
              });

              setTimeout(() => location.reload(), 1500);
            });
        }
      });

    }
  });

}


//////////////////////////////////////////////////////////
 verlentess(idlentes:any){
     this.idlentes=idlentes;
     this.getLentesssId();
     this.inventarioService.getlentesId(idlentes)
     .subscribe(
       res=> {
   
         if(res=="TOKEN-EXPIRADO"){
           this.msj.tokenExpiradoCerrarSesion();  
           return; 
       }
   
         this.lentesinfo = res;
        const fechainiciop = String (this.lentesinfo.fecha_factura).split('T')[0];
        this.lentesinfo.fecha_factura = fechainiciop;
        const fechainiciop1 = String (this.lentesinfo.fecha_receta).split('T')[0];
        this.lentesinfo.fecha_receta = fechainiciop1; 
        const fechainiciop2 = String (this.lentesinfo.fecha_pago).split('T')[0];
        this.lentesinfo.fecha_pago = fechainiciop2;
        const fechainiciop3 = String (this.lentesinfo.fecha_oficio).split('T')[0];
        this.lentesinfo.fecha_oficio = fechainiciop3;
const fechainiciop4 = String (this.lentesinfo.fechapago).split('T')[0];
        this.lentesinfo.fechapago = fechainiciop4;

       },
       err=>console.log(err)
     )
   }
   ////////////////////////////////////////////editar/////////////////////////////////////////////
   getLentesssId(){
     this.inventarioService.getlentesId(this.idlentes)
     .subscribe(
       res=> {
   
         if(res=="TOKEN-EXPIRADO"){
           this.msj.tokenExpiradoCerrarSesion();   
           return;
       }
   
         this.lentesinfo = res;
        const fechainiciop = String (this.lentesinfo.fecha_factura).split('T')[0];
        this.lentesinfo.fecha_factura = fechainiciop;
        const fechainiciop1 = String (this.lentesinfo.fecha_receta).split('T')[0];
        this.lentesinfo.fecha_receta = fechainiciop1;
        const fechainiciop2 = String (this.lentesinfo.fecha_pago).split('T')[0];
        this.lentesinfo.fecha_pago = fechainiciop2;
        const fechainiciop3 = String (this.lentesinfo.fecha_oficio).split('T')[0];
        this.lentesinfo.fecha_oficio = fechainiciop3;
        const fechainiciop4 = String (this.lentesinfo.fechapago).split('T')[0];
        this.lentesinfo.fechapago = fechainiciop4;
       },
       err=>console.log(err)
     )
   
   }



  editarLentes() {
  this.inventarioService.updateLentes(this.idlentes, this.lentesinfo).subscribe(
    res => {

      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      Swal.fire({
        title: '<span style="font-size:22px; color:#8f124d; font-weight:600;">¡Datos actualizados!</span>',
        html: `
          <p style="text-align:center; color:#555; font-size:15px; margin:10px 0 0;">
            Los cambios se han guardado correctamente.
          </p>
        `,
        icon: 'success',
        iconColor: '#c5ab5b',
        background: '#fff',
        showConfirmButton: false,
        timer: 1500,
        allowOutsideClick: false,
        backdrop: 'rgba(0,0,0,0.3)',
        customClass: {
          popup: 'shadow-lg rounded-4 border-top border-3 border-warning'
        },
        showClass: {
          popup: 'animate__animated animate__zoomIn'
        },
        hideClass: {
          popup: 'animate__animated animate__zoomOut'
        }
      });

      setTimeout(() => location.reload(), 1500);
    },
    err => {
      console.error(err);

      Swal.fire({
        title: '<span style="font-size:22px; color:#8f124d; font-weight:600;">Error al actualizar</span>',
        html: `
          <p style="text-align:center; color:#555; font-size:15px; margin:10px 0 0;">
            Ocurrió un problema al guardar los datos. Intente nuevamente.
          </p>
        `,
        icon: 'error',
        iconColor: '#d33',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#720f3c',
        background: '#fff',
        backdrop: 'rgba(0,0,0,0.3)',
        allowOutsideClick: false,
        customClass: {
          popup: 'shadow-lg rounded-4 border-top border-3 border-danger'
        },
        showClass: {
          popup: 'animate__animated animate__shakeX'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOut'
        }
      });
    }
  );
}
///////////////////////////////////
abrirAgregarXML(id: number) {
  this.idlentes = id;   // 🔑 GUARDAMOS LA BECA SELECCIONADA
  $('#Agrexml').modal('show');
}

cerrarAgregarXML() {
  $('#Agrexml').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 500);
}

   cerrarPreviewXML() {
  $('#previewXML').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 1000);
}

  onFileSelected(event: any) {
    this.archivo = event.target.files[0];
    if (!this.archivo) return;

    const reader = new FileReader();

    reader.onload = () => {
      const xmlText = reader.result as string;

      // Parsear y extraer datos
      this.parseXML(xmlText);

     
      $('#Agrexml').modal('hide');

      setTimeout(() => {
        $('#previewXML').modal('show');
      }, 200); 
    };

    reader.readAsText(this.archivo);
  }

parseXML(xmlString: string) {

  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");

  const comprobante = xml.getElementsByTagName("cfdi:Comprobante")[0];
  const emisor = xml.getElementsByTagName("cfdi:Emisor")[0];
  const receptor = xml.getElementsByTagName("cfdi:Receptor")[0];
  const timbre = xml.getElementsByTagName("tfd:TimbreFiscalDigital")[0];

  const traslados = xml.getElementsByTagName("cfdi:Traslado");
  const retenciones = xml.getElementsByTagName("cfdi:Retencion");

  let subtotal = parseFloat(comprobante?.getAttribute("SubTotal") || "0");
  let total = parseFloat(comprobante?.getAttribute("Total") || "0");
  let descuento = parseFloat(comprobante?.getAttribute("Descuento") || "0");

  let base16 = 0;
  let iva16 = 0;
  let base0 = 0;
  let impuestos = 0;
  let isrRetenido = 0;

  
  for (let i = 0; i < traslados.length; i++) {

    const tasa = traslados[i].getAttribute("TasaOCuota");
    const base = parseFloat(traslados[i].getAttribute("Base") || "0");
    const importe = parseFloat(traslados[i].getAttribute("Importe") || "0");

    impuestos += importe;

    if (tasa === "0.160000") {
      base16 += base;
      iva16 += importe;
    }

    if (tasa === "0.000000") {
      base0 += base;
    }
  }

  for (let i = 0; i < retenciones.length; i++) {

    const impuesto = retenciones[i].getAttribute("Impuesto");
    const importe = parseFloat(retenciones[i].getAttribute("Importe") || "0");

    if (impuesto === "001") { 
      isrRetenido += importe;
    }
  }

  this.xmlPreview = {
    folio: comprobante?.getAttribute("Folio") || '',
    subtotal: subtotal.toFixed(2),
    descuento: descuento.toFixed(2),
    total: total.toFixed(2),

    base16: base16.toFixed(2),
    iva16: iva16.toFixed(2),
    base0: base0.toFixed(2),
    impuestos: impuestos.toFixed(2),
    isr: isrRetenido.toFixed(2),

    rfc_emisor: emisor?.getAttribute("Rfc") || '',
    nombre_emisor: emisor?.getAttribute("Nombre") || '',

    rfc_receptor: receptor?.getAttribute("Rfc") || '',
    nombre_receptor: receptor?.getAttribute("Nombre") || '',

    uuid: timbre?.getAttribute("UUID") || '',
    no_certificado_sat: timbre?.getAttribute("NoCertificadoSAT") || ''
  };
}

  extract(xml: string, regex: RegExp) {
    const match = xml.match(regex);
    return match ? match[1] : '';
  }

confirmarXML() {

  if (!this.idlentes) {
    Swal.fire('Error', 'No se encontró el apoyo seleccionado', 'error');
    return;
  }

  const payload = {
    ...this.xmlPreview,
    idlentes: this.idlentes   
  };

  this.inventarioService.guardarXMLmanuallentes(payload).subscribe({
    next: () => {
      Swal.fire('XML guardado correctamente', '', 'success');
      this.cerrarPreviewXML();

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    error: err => {
      Swal.fire(
        'Error',
        err.error?.message || 'Error al guardar el XML',
        'error'
      );
    }
  });
}
//////////////////////
copiarTexto(texto: string) {
  if (!texto) return;

  navigator.clipboard.writeText(texto).then(() => {

     Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Copiado al portapapeles',
          showConfirmButton: false,
          timer: 1400,
          timerProgressBar: true,
          background: '#720f3c',
          color: '#ffffff'
        });

  
  }).catch(() => {
    Swal.fire({
      icon: 'error',
      title: 'Error al copiar',
      text: 'No se pudo copiar la información',
      confirmButtonColor: '#720f3c'
    });
  });
}

irASAT() {
  window.open(
    'https://verificacfdi.facturaelectronica.sat.gob.mx/',
    '_blank'
  );
}

////////////////////////
calcularSubtotal(): number {
  if (!this.xmlPreview.conceptos) return 0;
  return this.xmlPreview.conceptos
    .reduce((acc, c) => acc + Number(c.base), 0);
}

calcularIVA(): number {
  if (!this.xmlPreview.impuestos) return 0;
  return this.xmlPreview.impuestos
    .reduce((acc, i) => acc + Number(i.importe), 0);
}

calcularTotal(): number {
  return this.calcularSubtotal() + this.calcularIVA();
}

verXMLsss(folio_sat: any) {

  this.inventarioService.getxmllentesId(folio_sat).subscribe(
    (res: any) => {

      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      console.log("XML recibido:", res);

      this.xmlPreview = res; // 👈 aquí

    },
    err => console.error(err)
  );
}

}
